import { render, staticRenderFns } from "./SubmissionPolaroid.vue?vue&type=template&id=3de19f26&scoped=true&"
import script from "./SubmissionPolaroid.vue?vue&type=script&lang=js&"
export * from "./SubmissionPolaroid.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionPolaroid.vue?vue&type=style&index=0&id=3de19f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de19f26",
  null
  
)

export default component.exports